import callApi from "./callApi";

const resetOverlaySession = () => {
  callApi((api) => api.overlayMessaging?.resetSession());
};

export default resetOverlaySession;
